import React, { useState } from "react";
import { isEmpty, size } from "lodash";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import FileUploading from "../files-uploading/FilesUploading";
import CollectionHeaderPartner from "../collection-header-partner/CollectionHeaderPartner";
import {
  cancelUploadingFiles,
  retryUploadErrors,
} from "../../../services/uploadImages.service";
import {
  SECTION_PHOTO_GALLERY_COMPONENTS,
  STD_ERROR_MESSAGE,
} from "../../../utils/constant";
import { clearUploadFilesState } from "../../../redux/upload-files/uploadFiles.action";
import {
  addImagesInAGalleryFolderPromise,
  getImagesOfGalleryFolder,
} from "../../../services/gallery.service";

const PhotoGalleryFilesUploading = (props) => {
  const { currGalleryFolderInfo } = props;

  const uploadFilesState = useSelector((state) => state.uploadFiles);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const params = useParams();

  function handleUploadImageStatusCount(statusRole) {
    if (
      size(uploadFilesState.fileProgress) ===
      size(uploadFilesState.uploadSuccess.ids) +
        size(uploadFilesState.uploadError.ids)
    ) {
      if (statusRole === "success") {
        return `Successful Uploads: ${size(
          uploadFilesState.uploadSuccess.ids
        )}`;
      } else {
        if (size(uploadFilesState.uploadError.ids) > 0) {
          return `Errors: ${size(uploadFilesState.uploadError.ids)}`;
        } else {
          return "";
        }
      }
    } else {
      return "";
    }
  }

  function isUploadProgressing() {
    return (
      size(uploadFilesState.fileProgress) >
      size(uploadFilesState.uploadSuccess.ids) +
        size(uploadFilesState.uploadError.ids)
    );
  }

  function handleRetryBtnEvent() {
    dispatch(retryUploadErrors());
  }

  function uploadHasErrors() {
    return size(uploadFilesState.uploadError.ids) > 0;
  }

  function handleProceedBtnEvent() {
    if (!submitting) {
      setSubmitting(true);
      if (size(uploadFilesState.uploadSuccess.ids)) {
        const galleryImageRequest = [];
        for (const id of uploadFilesState.uploadSuccess.ids) {
          const fileData = uploadFilesState.fileProgress[id];
          galleryImageRequest.push({
            image_id: fileData.imageId,
          });
        }
        addImagesInAGalleryFolderPromise(
          params.collectionId,
          currGalleryFolderInfo.id,
          { gallery_image_request: galleryImageRequest }
        )
          .then((res) => {
            setSubmitting(false);
            dispatch(
              getImagesOfGalleryFolder(
                params.collectionId,
                currGalleryFolderInfo.id
              )
            );
            props.setCurrentMainComponent((prevState) => {
              return {
                currComponent:
                  SECTION_PHOTO_GALLERY_COMPONENTS.photo_gallery_list,
                prevComponent: prevState.currComponent,
              };
            });
            dispatch(clearUploadFilesState());
          })
          .catch((err) => {
            setSubmitting(false);
            toast.error(
              !isEmpty(err?.data?.error_data)
                ? err?.data?.error_data
                : STD_ERROR_MESSAGE
            );
          });
      } else {
        setSubmitting(false);
        props.setCurrentMainComponent((prevState) => {
          return {
            currComponent: SECTION_PHOTO_GALLERY_COMPONENTS.photo_gallery_list,
            prevComponent: prevState.currComponent,
          };
        });
        dispatch(clearUploadFilesState());
      }
    }
  }

  function handleAddPhotosBtnEvent() {
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_PHOTO_GALLERY_COMPONENTS.upload_photo_gallery,
        prevComponent: prevState.currComponent,
      };
    });
  }

  function handleCancelBtnEvent() {
    dispatch(cancelUploadingFiles());
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_PHOTO_GALLERY_COMPONENTS.photo_gallery_list,
        prevComponent: prevState.currComponent,
      };
    });
  }

  return (
    <>
      <CollectionHeaderPartner
        title={`Adding Photos to ${currGalleryFolderInfo.title}`}
        uploadSuccessContent={handleUploadImageStatusCount("success")}
        uploadErrorContent={handleUploadImageStatusCount("failure")}
        cancelBtn={isUploadProgressing()}
        handleCancelBtnClick={handleCancelBtnEvent}
        retryBtn={!isUploadProgressing() && uploadHasErrors()}
        handleRetryBtnClick={handleRetryBtnEvent}
        addPhotosBtn={!isUploadProgressing()}
        addPhotosLabel="Add More"
        handleAddPhotosBtn={handleAddPhotosBtnEvent}
        loadingBtn={!isUploadProgressing()}
        loadingBtnProps={{
          loading: submitting,
          onClick: handleProceedBtnEvent,
        }}
        loadingBtnLabel="Proceed"
      />
      <FileUploading />
    </>
  );
};

export default PhotoGalleryFilesUploading;
